import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import { ApiClientUtils } from 'fwork-jsts-common/src/apiClient'
import { useSnackbar } from 'notistack'
import React from 'react'
import { DEFAULTGAP } from '../../globals'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { IDotEnvProductionState } from '../../redux/reducers/dotenvProduction.slice'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'

interface EventsPopupComponentProps {
  onFileSelected: (file: File, url: string | undefined) => void
  onCloseMenu: () => void
  anchorEl: null | HTMLElement
}

export const EventsPopupComponent: React.FC<EventsPopupComponentProps> = ({ onFileSelected, onCloseMenu, anchorEl }) => {
  const dotEnvProductionState: IDotEnvProductionState = useSelector((state: RootState) => state.dotEnvProductionState)
  const { enqueueSnackbar } = useSnackbar()

  const convertUrlToFile = async (imgUrl: string): Promise<File | null> => {
    try {
      const response = await fetch(imgUrl)
      const blob = await response.blob()
      return new File([blob], 'image.png', { type: 'image/png' })
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(`Erro ao carregar imagem: ${error}`), { variant: 'error' })
      return null
    }
  }

  const convertFileToBase64 = (file: File | undefined): Promise<string | null> => {
    return file
      ? new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result as string)
        reader.readAsDataURL(file)
      })
      : Promise.resolve(null)
  }

  const handleSelectImgChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const file = event.target.files?.[0] as File
      if (file) {
        const base64 = await convertFileToBase64(file)
        onFileSelected(file, base64 || undefined)
      } else {
        console.log("No file selected")
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleImageUrlChange = async (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const url = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.webproxy.replace(':url', encodeURIComponent(event.target.value))}`
    const file = await convertUrlToFile(url)
    if (file)
      onFileSelected(file, url)
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onCloseMenu}
      onClick={(e) => { e.stopPropagation() }}
    >
      <MenuItem onClick={() => document.getElementById("fileInput")?.click()} style={{ gap: 10, width: 350, paddingBlock: 10 }}>
        <div style={{
          display: 'flex',
          gap: DEFAULTGAP,
        }}>
          <CloudUploadIcon />
          <div> Selecionar Imagem</div>
        </div>
        <input
          id="fileInput"
          type="file"
          onChange={handleSelectImgChange}
          accept='image/png'
          style={{ display: 'none' }}
        />
      </MenuItem>

      <MenuItem
        disableRipple
        sx={{
          '&:hover': {
            backgroundColor: 'inherit',
          },
        }}
        style={{
          marginTop: 10
        }}>
        <TextField
          size='small'
          placeholder="Cole a url da imagem aqui..."
          onChange={handleImageUrlChange}
          style={{
            width: '100%',
            boxSizing: 'border-box',
          }}
        />
      </MenuItem>
    </Menu>
  )
}